import { AccordionItem, AccordionTrigger, AccordionContent } from "@fastly/consistently"
import styled, { css, keyframes } from "styled-components"

const tokens = css`
  --accordion-height: auto;
`
const slideDown = keyframes`
  from {
    height: 0;
  }
  to {
    height: var(--radix-collapsible-content-height);
  }
`

const slideUp = keyframes`
  from {
    height: var(--radix-collapsible-content-height);
  }
  to {
    height: 0;
  }
`

const Package = styled.div`
  border-radius: var(--size-radius-2xl);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
`

const PackageLayout = styled.div`
  padding: var(--size-space-lg);
  ul {
    padding-left: var(--size-space-lg);
  }
  li {
    padding-bottom: var(--size-space-md);
  }
  p {
    margin: 0;
  }
`
const PackageSection = styled.div`
  ${Package} > &:first-child {
    background-color: var(--color-grey-10);
  }
  ${Package} > &:nth-child(2) {
    background-color: var(--color-grey-5);
  }
`

const PackageAccordionTrigger = styled(AccordionTrigger)``

const PackageAccordionItem = styled(AccordionItem)`
  & > div:nth-of-type(1) {
    border-bottom: none;
  }
`
const PackageAccordionContent = styled(AccordionContent)`
  ${tokens}
  font-weight: 700;
  font-size: var(--font-size-sm);
  height: var(--accordion-height);
  animation: ${slideUp} 300ms ease-in-out;
  background: var(--color-white);
  &[data-state="open"] {
    animation: ${slideDown} 300ms ease-in-out;
    height: var(--accordion-height);
  }
`

export {
  Package,
  PackageLayout,
  PackageSection,
  PackageAccordionContent,
  PackageAccordionItem,
  PackageAccordionTrigger,
}
